import { render, staticRenderFns } from "./EmpresaAdminView.vue?vue&type=template&id=0fbdf497&"
import script from "./EmpresaAdminView.vue?vue&type=script&lang=js&"
export * from "./EmpresaAdminView.vue?vue&type=script&lang=js&"
import style0 from "./EmpresaAdminView.vue?vue&type=style&index=0&id=0fbdf497&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports